import { AutocompleteType, RadioType,TextFieldType ,DatePickerType} from "@utilifiles/component/CustomFormElement"
import dayjs from "dayjs"

type appointmentFieldType={
    department:AutocompleteType,
    doctor:AutocompleteType,
    visitType:AutocompleteType,
    visitPurpose:AutocompleteType
    HIE:RadioType
    refferedBy:AutocompleteType
    referenceSource:AutocompleteType
    grouping:AutocompleteType
    postOffice:AutocompleteType
    paymentType:RadioType
}
type insuranceFieldType={
    insuranceType:AutocompleteType,
    TPA:AutocompleteType
    Insurance:AutocompleteType
    InsuranceName:AutocompleteType  
    InsurancePlan:AutocompleteType
    CardNumber:TextFieldType
    PolicyNumber:TextFieldType
    PolicyFrom:DatePickerType
    PolicyTill:DatePickerType
    AsopNo:TextFieldType

}


const AppointmentformData:appointmentFieldType={
        department:{
            element:"autocomplete",
            name:"department",
            fieldProps:{label:"Department"},
            rules:{required:"department Required"},
            autocompleteProps: {
                getOptionLabel: (option) => option.departmentName?? "",
                isOptionEqualToValue: (option, value) => option.departmentId == value.departmentId,
              }
        },
        doctor:{
            element:"autocomplete",
            name:"doctor",
            fieldProps:{label:"Doctor"},
            rules:{required:"doctor Required"},
            autocompleteProps: {
                getOptionLabel: (option) => option.doctorName?? "",
                isOptionEqualToValue: (option, value) => option.doctorId == value.doctorId,
              }
        },
        visitType:{
            element:"autocomplete",
            name:"visitType",
            fieldProps:{label:"Visit Type"},
            rules:{required:"visitType Required"},
            autocompleteProps: {
                getOptionLabel: (option) => option.visitType?? "",
                isOptionEqualToValue: (option, value) => option.Id == value.Id,
              }
        },
        visitPurpose:{
            element:"autocomplete",
            name:"visitPurpose",
            fieldProps:{label:"Visit Purpose"},
            rules:{required:"visitPurpose Required"},
            autocompleteProps: {
                getOptionLabel: (option) => option.purposeName?? "",
                isOptionEqualToValue: (option, value) => option.purposeId == value.purposeId,
              }
        },
        postOffice: {
          element: "autocomplete",
          name: "postofficeId",
          fieldProps: { label: "Post Office" },
          rules: { required: "Post office required" },
          autocompleteProps: {
            getOptionLabel: (option) => option.poName?? "",
            isOptionEqualToValue: (option, value) => option.poId == value.poId,
          },
        },
        HIE:{
            element: "radio",
            name: "HIE",
            radios: [{ value: 0, label: "Global OptIn" }, { value: 1, label: "Global OptOut" }],
            fieldProps: {label:"Riayati Consent"},
            rules: {required:true},
            radioProps: { label: "Raiyati consent required",row:true }
        },
        refferedBy:{
            element:"autocomplete",
            name:"refferedby",
            fieldProps:{label:"Reffered By"},
            rules:{required:false},
            autocompleteProps: {
                getOptionLabel: (option) => option.clcn_name?? "",
                isOptionEqualToValue: (option, value) => option.clcn_name == value.clcn_name,
              }
            
        },
        referenceSource:{
            element:"autocomplete",
            name:"ReferenceSource",
            fieldProps:{label:"How do you know about this"},
            rules:{required:false},
            autocompleteProps: {
                getOptionLabel: (option) => option.type ?? "",
                isOptionEqualToValue: (option, value) => option.type == value.type,
              }
          
        },
        grouping:{
            element:"autocomplete",
            name:"grouping",
            fieldProps:{label:"Grouping"},
            rules:{required:false},
            autocompleteProps: {
                getOptionLabel: (option) => option.name?? "",
                isOptionEqualToValue: (option, value) => option.name == value.name,
              }
        },
        paymentType:{
            element: "radio",
            name: "PaymentMode",
            radios: [{ value: 0, label: "Cash" }, { value: 1, label: "Insurance" }],
            fieldProps: {label:"Payment Mode"},
            rules: {required:true},
            radioProps: { row:true }
        },

}

const InsuranceFormData:insuranceFieldType={

    insuranceType:{
        element:"autocomplete",
        name:"insuranceType",
        fieldProps:{label:"Insurance Type"},
        rules:{required:"insuranceType Required"},
        autocompleteProps: {
            getOptionLabel: (option) => option.name?? "",
            isOptionEqualToValue: (option, value) => option.id == value.id,
          }
    },
    TPA:{
        element:"autocomplete",
        name:"TPA",
        fieldProps:{label:"Recever"},
        rules:{required:"Receiver Required"},
        autocompleteProps: {
            getOptionLabel: (option) => option.name?? "",
            isOptionEqualToValue: (option, value) => option.id == value.id,
          }
    },
    Insurance:{
        element:"autocomplete",
        name:"Insurance",
        fieldProps:{label:"Receiver"},
        rules:{required:"Payer is Required"},
        autocompleteProps: {
            getOptionLabel: (option) => option.name?? "",
            isOptionEqualToValue: (option, value) => option.id == value.id,
          }
    },
    InsuranceName:{
        element:"autocomplete",
        name:"InsuranceName",
        fieldProps:{label:"Payer "},
        rules:{required:"Payer Required"},
        autocompleteProps: {
            getOptionLabel: (option) => option.name?? "",
            isOptionEqualToValue: (option, value) => option.id == value.id,
          }
    },
    InsurancePlan:{
        element:"autocomplete",
        name:"InsurancePlan",
        fieldProps:{label:"Insurance plan"},
        rules:{required:"InsurancePlan Required"},
        autocompleteProps: {
            getOptionLabel: (option) => option.name?? "",
            isOptionEqualToValue: (option, value) => option.name == value.name,
          }
    },
    CardNumber:{
        element: "input",
        name: "cardNumber",
        fieldProps: { label: "card Number",type:'text' },
        rules: { required: "cardNumber required" },
      },
      PolicyFrom:{
        element:"datepicker",
        name:"PolicyFrom",
        dateFormat:'DD-MM-YYYY',
        fieldProps: { label: "Policy Valid From ", type:"date" },
        calenderProps:{maxDate:dayjs()},
        rules: { required:false},
      },
      PolicyTill:{
        element:"datepicker",
        name:"PolicyTill",
        dateFormat:'DD-MM-YYYY',
        fieldProps: { label: "Policy Valid Till ", type:"date"},
        calenderProps:{},
        rules: { required:"policy end date is required"},
      },
      AsopNo:{
        element:"input",
        name:"AsopNo",
        fieldProps: { label: "Asop Number",type:'number' },
        rules: { required: false },

      },
      PolicyNumber:{
        element:"input",
        name:"PolicyNumber",
        fieldProps: { label: "Policy Number",type:'text' },
        rules: { required: false }
      }

}

export const GROUPING_OPTIONS = [
  { id: 1, name: "Royal Family" },
  { id: 2, name: "company" },
];

export const resolveEncounterGrouping = (encounterDetails: {
  encounter?: { grouping?: string | null };
  pmaster?: { grouping?: string | null; groupingFamily?: string | null };
} | null) => {
  const groupingName =
    encounterDetails?.encounter?.grouping ??
    encounterDetails?.pmaster?.groupingFamily ??
    encounterDetails?.pmaster?.grouping ??
    null;

  if (!groupingName) return null;

  return (
    GROUPING_OPTIONS.find((option) => option.name === groupingName) ?? {
      id: 0,
      name: groupingName,
    }
  );
};

export {AppointmentformData,InsuranceFormData}

